import * as React from 'react';

import classnames from 'classnames';

import {getDurationString} from 'nutshell-core/utils';

import {colors} from 'shells/colors/colors';
import {ClockIcon} from 'shells/icon';

import type {EmailAutomation_delay} from 'nutshell-graphql-types';

import styles from './rows.module.css';

type Props = {
    delay: EmailAutomation_delay | null | undefined;
    entersStage: {
        name: string;
    };
};

export function Delay(props: Props) {
    return (
        <div className={classnames('flex', styles.row)}>
            <div className={styles['line-icon']}>
                {/* @ts-expect-error */}
                <ClockIcon fill={colors.greyLt} />
            </div>
            {props.delay ? (
                <span style={{textOverflow: 'ellipsis'}}>
                    {props.delay.timespan}{' '}
                    {getDurationString(props.delay.unit, props.delay.timespan !== 1)} after the lead
                    enters <strong>{props.entersStage.name}</strong>
                </span>
            ) : null}
        </div>
    );
}
